module.exports = __webpack_public_path__ + "static/media/bharat-qr.481e19e1.svg";